import {load} from '@shopify/theme-sections';

import '../sections/hero-slider';
import '../sections/featured-collection';
import '../sections/featured-media';
import '../sections/featured-products';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
